import debounce from 'lodash/debounce';
import * as React from 'react';
export function useResize(params) {
    const refWindowHeight = React.useRef();
    const refWindowWidth = React.useRef();
    const onResize = React.useCallback(debounce(() => {
        const prevHeight = refWindowHeight.current;
        const prevWidth = refWindowWidth.current;
        const newHeight = window.innerHeight;
        const newWidth = window.innerWidth;
        const shouldTrigger = params.on === 'both' ||
            (params.on === 'y' && prevHeight !== newHeight) ||
            (params.on === 'x' && prevWidth !== newWidth);
        if (shouldTrigger) {
            params.callback();
        }
        refWindowHeight.current = newHeight;
        refWindowWidth.current = newWidth;
    }, params.debounce), [params.debounce, params.on]);
    React.useEffect(() => {
        if (!params.callback) {
            return;
        }
        if (params.immediate) {
            onResize();
        }
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [params.on]);
}
